var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#3D3D3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.834 25.167H25.1673C21.7911 25.167 19.1144 27.8741 19.1144 31.2503L19.084 67.7503C19.084 71.1266 21.7911 73.8337 25.1673 73.8337H73.834C77.2102 73.8337 79.9173 71.1266 79.9173 67.7503V31.2503C79.9173 27.8741 77.2102 25.167 73.834 25.167ZM73.834 67.7503H25.1673V49.5003H73.834V67.7503ZM73.834 37.3337H25.1673V31.2503H73.834V37.3337Z",
    fill: "#42CFC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCircle);
export default __webpack_public_path__ + "static/media/card-circle.eb76ae71630f9a62ccb67f2db7f80786.svg";
export { ForwardRef as ReactComponent };